// i18n dictionary for Prime Vision landing — Italian + English
const dict = {
  it: {
    nav: {
      home: 'Home',
      about: 'Chi siamo',
      why: 'Perché sceglierci',
      target: 'A chi ci rivolgiamo',
      eventi: 'Eventi',
      contact: 'Contatti',
      solution: 'Soluzione',
      login: 'Accedi',
      demo: 'Vedi la demo',
    },

    hero: {
      eyebrow: 'Per studi oculistici che vogliono più controllo, meno burocrazia.',
      release_badge: 'Disponibile dall\'inizio del 2027',
      preorder_badge: 'Pre-order aperti · Offerte competitive',
      manifesto: {
        line1_a: 'Più visione clinica.',
        line1_b: 'Meno burocrazia.',
        line2: 'Massima qualità assistenziale. Minimo sforzo gestionale.',
      },
      title_a: 'Meno burocrazia. Più visite.',
      title_b: 'Uno studio che finalmente gira.',
      subtitle:
        'Prime Vision organizza cartella clinica, AI vocale, agenda, fatture, follow-up e percorso FSE 2.0 a norma in un unico flusso per studi oculistici moderni.',
      cta_demo: 'Voglio vedere la demo',
      cta_survey: 'Fai il test per il tuo studio',
      cta_contact: 'Richiedi informazioni',
      cta_brochure: 'Scarica la brochure',
      trust_label: '30 minuti, zero impegno. Ti mostriamo dove il tuo studio perde ore ogni settimana.',
      kpi: [
        { label: 'Ore recuperate', value: '+12h/sett.' },
        { label: 'Software unificati', value: '7 → 1' },
        { label: 'Conforme', value: 'GDPR · FSE 2.0' },
      ],
      mockupTitle: 'Cartella paziente — Visita oculistica',
    },

    problem: {
      eyebrow: 'Il problema',
      lossTag: 'Perdita',
      title_a: 'Ogni software in più è una perdita nascosta.',
      title_b: 'Tempo, controllo, pazienti.',
      body:
        'Quando cartelle, agenda, immagini, fatture e follow-up non parlano tra loro, il costo non è solo tempo: è controllo perso, pazienti meno seguiti, team sotto pressione. Alla fine della giornata il medico ha gestito dati invece di fare medicina.',
      items: [
        'Il medico visita, poi rincorre il referto.',
        'La segreteria coordina tutto a mano.',
        'I dati esistono, ma non sono mai dove servono.',
        'Documentazione clinica frammentata in software diversi',
        'Telefonate continue per spostare appuntamenti',
        'Follow-up dimenticati o gestiti su carta',
      ],
      transition_cta: 'Ti riconosci in questo? Vedi come cambia con Prime Vision',
    },

    validation: {
      eyebrow: 'Quello che gli oculisti ci hanno detto',
      title_a: 'Il problema che quasi tutti',
      title_b: 'sottovalutano: il caos operativo.',
      lead:
        'Dalle conversazioni con gli oculisti emerge una cosa: non manca lavoro. Mancano flussi che trasformano il lavoro in un processo ordinato.',
      stats: [
        { value: '95%', label: 'Vuole automatizzare le attività non cliniche' },
        { value: '78%', label: 'Sente un carico amministrativo eccessivo' },
        { value: '71%', label: 'Fatica a ritrovare documentazione clinica al volo' },
        { value: '64%', label: 'Ha dati clinici sparsi tra software diversi' },
        { value: '58%', label: 'Gestisce agenda e follow-up a mano' },
      ],
      footer: 'Fonte: sondaggio Prime Vision condotto su oculisti italiani.',
    },

    surveyCharts: {
      title_a: 'I dati del sondaggio,',
      title_b: 'in chiaro.',
      charts: [
        {
          question: 'Quanto tempo perdi ogni giorno in attività non mediche?',
          subtitle: 'Tempo amministrativo medio per giornata di studio',
          slices: [
            { label: '< 30 minuti', value: 11.1, color: '#3B82F6' },
            { label: '30 – 60 minuti', value: 59.3, color: '#EF4444' },
            { label: '1 – 2 ore', value: 22.2, color: '#F59E0B' },
            { label: 'Oltre 2 ore', value: 7.4, color: '#10B981' },
          ],
          insight: 'Quasi 9 oculisti su 10 perdono oltre 30 minuti al giorno in attività non mediche.',
        },
        {
          question: 'Il problema non sono i pazienti, ma tutto ciò che rimane dopo la visita.',
          subtitle: 'Quanto sei d\'accordo con questa affermazione?',
          slices: [
            { label: 'Per niente', value: 3.8, color: '#3B82F6' },
            { label: 'Poco', value: 18.5, color: '#EF4444' },
            { label: 'Abbastanza', value: 44.4, color: '#F59E0B' },
            { label: 'Molto', value: 33.3, color: '#10B981' },
          ],
          insight: '78% degli oculisti è abbastanza o molto d\'accordo: il carico post-visita è il vero problema.',
        },
      ],
    },

    solution: {
      eyebrow: 'La soluzione',
      title_a: 'Prime Vision elimina',
      title_b: 'la frammentazione.',
      lead:
        'Tutto ciò che oggi è sparso in più software viene riunito in un unico ecosistema intelligente.',
      blocks: [
        {
          tag: '01 · CARTELLA CLINICA',
          title: 'Referti più veloci senza togliere attenzione al paziente.',
          desc:
            'Detti la visita, l\'AI vocale struttura il referto. Anamnesi, terapie e storico sempre nello stesso punto. Il medico torna a guardare il paziente, non lo schermo.',
          bullets: [
            'Referto vocale AI per oculistica',
            'Consenso informato vocale',
            'Campi sartoriali: retina, cornea, glaucoma, cataratta, refrattiva, strabismo',
            'Terapie e follow-up preimpostati',
          ],
        },
        {
          tag: '02 · DOCUMENTAZIONE CLINICA',
          title: 'Storia clinica del paziente in un solo punto.',
          desc:
            'Cartella, referti, terapie, allegati, follow-up: tutto unificato per paziente e ricercabile in due click. Niente passaggi su software diversi, niente carta da ritrovare.',
          bullets: ['Storia clinica unificata', 'Allegati per occhio e per data', 'Riferimenti incrociati con la cartella'],
        },
        {
          tag: '03 · FLUSSI A NORMA',
          title: 'Meno pratiche ripetitive, più tempo clinico.',
          desc:
            'Accettazione digitale, pagamenti, fatturazione, supporto a un flusso FSE 2.0 a norma, consensi, archiviazione. Meno errori, meno personale necessario.',
          bullets: ['Fatturazione elettronica', 'Percorso FSE 2.0 ordinato', 'Documenti a norma · consensi digitali'],
        },
        {
          tag: '04 · AGENDA SMART',
          title: 'Pazienti richiamati al momento giusto.',
          desc:
            'Reminder automatici, recall pazienti dormienti, percorsi pre e post operatori. Il paziente non viene mai dimenticato — e questo si trasforma in continuità di cura e fidelizzazione.',
          bullets: ['Reminder via SMS / email', 'Recall pazienti dormienti', 'Percorsi pre e post chirurgia'],
        },
        {
          tag: '05 · KPI',
          title: 'Quello che misuri, lo controlli.',
          desc:
            'Visite, prestazioni, fatturato, attese, produttività per medico e per sede. In tempo reale, in un\'unica dashboard. Decisioni veloci basate su dati, non su impressioni.',
          bullets: ['Dashboard KPI in tempo reale', 'Report mensili automatici', 'Analisi per medico e per sede'],
        },
      ],
    },

    comparison: {
      eyebrow: 'Perché sceglierci',
      title_a: 'Non vendiamo un gestionale.',
      title_b: 'Vendiamo ore recuperate, meno errori, più controllo.',
      lead:
        'La differenza non è una funzione in più. È il fatto che ogni funzione nasce dal flusso reale di uno studio oculistico — non da un foglio Excel di marketing.',
      headerGeneric: 'Gestionale generico',
      headerPV: 'Prime Vision',
      rows: [
        { feature: 'Anagrafica paziente', generic: true, pv: true },
        { feature: 'Agenda di base', generic: true, pv: true },
        { feature: 'Cartella clinica oculistica sartoriale', generic: false, pv: true },
        { feature: 'IA integrata per referto vocale', generic: false, pv: true },
        { feature: 'Consenso informato vocale', generic: false, pv: true },
        { feature: 'Documentazione clinica unificata per paziente', generic: false, pv: true },
        { feature: 'Workflow chirurgico pre e post operatorio', generic: false, pv: true },
        { feature: 'Percorso FSE 2.0 ordinato', generic: false, pv: true },
        { feature: 'Linee guida cliniche aggiornate (AICCER, ESCRS)', generic: false, pv: true },
        { feature: 'Paziente seguito anche a casa', generic: false, pv: true },
        { feature: 'Semplice da usare, anche per chi non è tecnico', generic: false, pv: true },
      ],
    },

    showcase: {
      eyebrow: 'Anteprima del software',
      title_a: 'Dal primo contatto al follow-up:',
      title_b: 'un flusso più ordinato per team e paziente.',
      lead:
        'Guarda come Prime Vision organizza cartella clinica, agenda, documenti e follow-up in un ambiente unico. Schermate reali, non render finti.',
      ctaUnder: 'Vedi Prime Vision in una demo di 30 minuti',
      tabs: [
        {
          key: 'login',
          label: 'Accesso sicuro',
          caption: 'Login multi-ruolo con Continua con Google + email/password. Tre ambienti distinti per Medico, Segreteria e Paziente. Crittografia AES-256 e conformità GDPR su tutta la sessione.',
          tag: '01 · ACCESSO',
        },
        {
          key: 'appuntamenti',
          label: 'Agenda intelligente',
          caption: 'Calendario completo multi-sede (Milano, Napoli, ovunque). Modifica, riassegna e gestisci tutti gli appuntamenti dei medici da un\'unica dashboard.',
          tag: '02 · AGENDA',
        },
        {
          key: 'linee',
          label: 'Linee guida sempre aggiornate',
          caption: 'AICCER, SICCSO, ESCRS e tutte le società scientifiche italiane ed europee, sempre disponibili nella scheda paziente. Decisioni cliniche supportate dalla letteratura aggiornata.',
          tag: '03 · KNOWLEDGE BASE',
        },
        {
          key: 'nuovo_appuntamento',
          label: 'Nuovi appuntamenti',
          caption: 'Crea un nuovo appuntamento in 3 click: paziente, sede, medico. Slot dinamici, motivi della visita preimpostati e conferma automatica via SMS.',
          tag: '04 · BOOKING',
        },
        {
          key: 'fatture',
          label: 'Gestione fatture',
          caption: 'Totale fatturato, incassato e da incassare in tempo reale. Emetti fattura in 2 click ed archivia in formato conforme FSE 2.0.',
          tag: '05 · FATTURAZIONE',
        },
        {
          key: 'statistiche',
          label: 'Performance medici',
          caption: 'Statistiche staff: visite totali, completate, cancellate, % completamento, attesa media e pazienti visti. Per ogni oculista, ogni giorno, ogni mese.',
          tag: '06 · KPI STAFF',
        },
      ],
    },

    target: {
      eyebrow: 'A chi ci rivolgiamo',
      title_a: 'Per studi che sono cresciuti oltre',
      title_b: 'fogli, note vocali e software scollegati.',
      lead:
        'Se il tuo studio è pieno ma il team lavora in emergenza, Prime Vision serve a riportare ordine senza rallentare la crescita.',
      cards: [
        { title: 'Studi oculistici privati', desc: 'Più visite gestite, senza più caos amministrativo.' },
        { title: 'Cliniche oculistiche', desc: 'Medici, sale, agenda e follow-up nello stesso sistema.' },
        { title: 'Centri chirurgici', desc: 'Percorsi più tracciati, meno passaggi manuali, meno errori.' },
        { title: 'Reti sanitarie', desc: 'Multi-sede, KPI consolidati, governance clinica uniforme.' },
      ],
    },

    ctaBlock: {
      surveyTag: '02 · QUESTIONARIO',
      surveyTitle: 'Il tuo studio è pronto per Prime Vision?',
      surveyDesc:
        'Compila il questionario. In pochi minuti scoprirai quanto tempo stai perdendo oggi, quali processi puoi automatizzare e se Prime Vision è adatto alla tua struttura.',
      surveyBtn: 'Fai il test',
      demoTag: '01 · CALL CONOSCITIVA',
      demoTitle: 'Una call di 30 min è il modo migliore per capirlo.',
      demoDesc:
        'Prenota una call gratuita con il nostro team: ti richiamiamo noi entro 24h e ti mostriamo come Prime Vision libera ore di lavoro amministrativo ogni settimana.',
      demoBtn: 'Prenota una call',
    },

    preorder: {
      eyebrow: 'Early access · 2027',
      title_a: 'I primi studi entreranno con condizioni',
      title_b: 'che non torneranno.',
      lead:
        'Chi si registra ora entra nella prima ondata di onboarding e blocca condizioni early-adopter prima del lancio inizio 2027: prezzo, setup prioritario, migrazione assistita.',
      perks: [
        { title: 'Prezzo bloccato', desc: 'Tariffa early-adopter garantita per i primi 24 mesi.' },
        { title: 'Setup prioritario', desc: 'I primi studi prenotati vengono attivati prima di tutti gli altri.' },
        { title: 'Migrazione gratuita', desc: 'Importazione anagrafiche, agende e fatturato dal vecchio gestionale.' },
        { title: 'Demo + consulenza', desc: 'Affiancamento dedicato di un consulente medico e di un product specialist.' },
      ],
      stamp: 'PRIMA ONDATA · POSTI LIMITATI',
      cta: 'Riserva il tuo posto',
      cta_secondary: 'Parla con noi',
    },

    contact: {
      eyebrow: 'Contatti',
      title_a: 'Se il tuo studio è già pieno, non ti serve più lavoro.',
      title_b: 'Ti serve più controllo.',
      lead:
        'Lascia i dati: ti ricontattiamo con una proposta concreta per capire se Prime Vision è adatto al tuo flusso. Niente standardizzato, niente sales aggressivo.',
      firstName: 'Nome',
      lastName: 'Cognome',
      email: 'Email',
      phone: 'Numero di telefono',
      birthDate: 'Data di nascita',
      message: 'Messaggio (facoltativo)',
      messagePlaceholder: 'Raccontaci come è organizzato oggi il tuo studio…',
      privacy_a: 'Accetto la',
      privacy_b: 'privacy policy',
      privacy_c: ' e il trattamento dei miei dati.',
      submit: 'Voglio essere ricontattato',
      submitting: 'Invio in corso…',
      success: 'Richiesta inviata. Ti contatteremo a breve.',
      error: 'Errore durante l\'invio. Riprova.',
      required: 'Campo obbligatorio',
    },

    footer: {
      tagline: 'Più visione clinica. Meno burocrazia. Massima qualità assistenziale con minimo sforzo gestionale.',
      links_company: 'Prime Vision',
      links_product: 'Prodotto',
      links_legal: 'Legale',
      access: 'Accedi',
      demo: 'Demo',
      contact: 'Contatti',
      survey: 'Sondaggio oculisti',
      privacy: 'Privacy policy',
      terms: 'Termini & condizioni',
      copyright: '© {year} Prime Vision · Tutti i diritti riservati',
      claim_a: 'Più visione clinica. Meno burocrazia.',
      claim_b: 'Massima qualità assistenziale. Minimo sforzo gestionale.',
    },
  },

  en: {
    nav: {
      home: 'Home',
      about: 'About',
      why: 'Why choose us',
      target: 'Who it’s for',
      eventi: 'Events',
      contact: 'Contact',
      solution: 'Solution',
      login: 'Sign in',
      demo: 'See the demo',
    },

    hero: {
      eyebrow: 'For eye-care practices that want more control, less paperwork.',
      release_badge: 'Available from early 2027',
      preorder_badge: 'Pre-orders open · Special pricing',
      manifesto: {
        line1_a: 'More clinical vision.',
        line1_b: 'Less paperwork.',
        line2: 'Maximum care quality. Minimum management effort.',
      },
      title_a: 'Less paperwork. More patients.',
      title_b: 'A practice that finally flows.',
      subtitle:
        'Prime Vision organises medical records, voice AI, agenda, billing, follow-up and a compliant FSE 2.0 process in a single flow for modern eye-care practices.',
      cta_demo: 'I want to see the demo',
      cta_survey: 'Take the practice test',
      cta_contact: 'Request information',
      cta_brochure: 'Download the brochure',
      trust_label: '30 minutes, zero commitment. We show you where your practice is losing hours every week.',
      kpi: [
        { label: 'Hours recovered', value: '+12h/week' },
        { label: 'Tools unified', value: '7 → 1' },
        { label: 'Compliant', value: 'GDPR · FSE 2.0' },
      ],
      mockupTitle: 'Patient record — Eye exam',
    },

    problem: {
      eyebrow: 'The problem',
      lossTag: 'Loss',
      title_a: 'Every extra tool is a hidden loss.',
      title_b: 'Time, control, patients.',
      body:
        'When records, agenda, images, invoices and follow-ups don\'t talk to each other, the cost is not just time: it\'s lost control, less-followed patients, a team under pressure. By the end of the day the doctor has managed data instead of practicing medicine.',
      items: [
        'The doctor examines, then chases the report.',
        'The front desk coordinates everything by hand.',
        'The data exists, but never where it\'s needed.',
        'Clinical documentation scattered across tools',
        'Endless calls to reschedule visits',
        'Follow-ups forgotten or kept on paper',
      ],
      transition_cta: 'Sounds familiar? See how it changes with Prime Vision',
    },

    validation: {
      eyebrow: 'What ophthalmologists told us',
      title_a: 'The problem almost everyone',
      title_b: 'underestimates: operational chaos.',
      lead:
        'From our conversations with ophthalmologists one thing emerges: it\'s not work that\'s missing. It\'s tools that turn work into an ordered flow.',
      stats: [
        { value: '95%', label: 'Wants to automate non-clinical activities' },
        { value: '78%', label: 'Feels an excessive administrative load' },
        { value: '71%', label: 'Struggles to retrieve clinical records on the fly' },
        { value: '64%', label: 'Has clinical data scattered across tools' },
        { value: '58%', label: 'Handles agenda and follow-ups by hand' },
      ],
      footer: 'Source: Prime Vision survey on Italian ophthalmologists.',
    },

    surveyCharts: {
      title_a: 'The survey data,',
      title_b: 'in plain numbers.',
      charts: [
        {
          question: 'How much time do you lose each day in non-medical activities?',
          subtitle: 'Average admin time per practice day',
          slices: [
            { label: '< 30 minutes', value: 11.1, color: '#3B82F6' },
            { label: '30 – 60 minutes', value: 59.3, color: '#EF4444' },
            { label: '1 – 2 hours', value: 22.2, color: '#F59E0B' },
            { label: 'Over 2 hours', value: 7.4, color: '#10B981' },
          ],
          insight: 'Almost 9 out of 10 ophthalmologists lose more than 30 minutes a day to non-medical work.',
        },
        {
          question: 'The problem is not the patients, but everything that comes after the visit.',
          subtitle: 'How much do you agree?',
          slices: [
            { label: 'Not at all', value: 3.8, color: '#3B82F6' },
            { label: 'A little', value: 18.5, color: '#EF4444' },
            { label: 'Enough', value: 44.4, color: '#F59E0B' },
            { label: 'A lot', value: 33.3, color: '#10B981' },
          ],
          insight: '78% of ophthalmologists strongly agree: post-visit workload is the real problem.',
        },
      ],
    },

    solution: {
      eyebrow: 'The solution',
      title_a: 'One single flow, from the doctor\'s voice',
      title_b: 'to the patient\'s follow-up.',
      lead:
        'Dictate the visit, link exams, automate reminders and paperwork, keep everything under control. Fewer manual steps, fewer errors, more clinical continuity.',
      blocks: [
        {
          tag: '01 · MEDICAL RECORD',
          title: 'Faster reports without taking attention off the patient.',
          desc:
            'You dictate the visit, the AI structures the report. Anamnesis, therapies and history always in the same place. The doctor goes back to looking at the patient, not the screen.',
          bullets: [
            'AI voice report for ophthalmology',
            'Voice-driven informed consent',
            'Tailored fields: retina, cornea, glaucoma, cataract, refractive, strabismus',
            'Preset therapies and follow-ups',
          ],
        },
        {
          tag: '02 · CLINICAL DOCUMENTATION',
          title: 'Patient clinical history in one place.',
          desc:
            'Medical record, reports, therapies, attachments, follow-ups: everything unified per patient and searchable in two clicks. No tool switching, no paper to chase.',
          bullets: ['Unified clinical history', 'Attachments per eye and per date', 'Cross-references with the medical record'],
        },
        {
          tag: '03 · COMPLIANT FLOW',
          title: 'Less repetitive paperwork, more clinical time.',
          desc:
            'Digital check-in, payments, e-invoicing, support for a compliant FSE 2.0 flow, consents, archiving. Fewer errors, less staff needed.',
          bullets: ['E-invoicing', 'Ordered FSE 2.0 process', 'Compliant documents · digital consents'],
        },
        {
          tag: '04 · SMART AGENDA',
          title: 'Patients recalled at the right moment.',
          desc:
            'Automatic reminders, dormant-patient recalls, pre- and post-op paths. Patients are never forgotten — which translates into continuity of care and retention.',
          bullets: ['SMS / email reminders', 'Dormant patients recall', 'Pre- and post-surgical paths'],
        },
        {
          tag: '05 · KPI',
          title: 'What you measure, you control.',
          desc:
            'Visits, services, revenue, wait times, productivity per doctor and location. Real time, single dashboard. Fast decisions based on data, not impressions.',
          bullets: ['Live KPI dashboard', 'Automatic monthly reports', 'Analytics per doctor and location'],
        },
      ],
    },

    comparison: {
      eyebrow: 'Why choose us',
      title_a: 'We don\'t sell software.',
      title_b: 'We sell recovered hours, fewer errors, more control.',
      lead:
        'The difference is not one extra feature. It\'s the fact that every feature is born from the real workflow of an ophthalmology practice — not from a marketing spreadsheet.',
      headerGeneric: 'Generic software',
      headerPV: 'Prime Vision',
      rows: [
        { feature: 'Patient registry', generic: true, pv: true },
        { feature: 'Basic agenda', generic: true, pv: true },
        { feature: 'Ophthalmology-tailored medical record', generic: false, pv: true },
        { feature: 'AI voice reporting', generic: false, pv: true },
        { feature: 'Voice-driven informed consent', generic: false, pv: true },
        { feature: 'Unified clinical records per patient', generic: false, pv: true },
        { feature: 'Pre/post surgical workflow', generic: false, pv: true },
        { feature: 'Ordered FSE 2.0 process', generic: false, pv: true },
        { feature: 'Updated clinical guidelines (AICCER, ESCRS)', generic: false, pv: true },
        { feature: 'Patient cared for at home too', generic: false, pv: true },
        { feature: 'Simple to use, even for non-tech staff', generic: false, pv: true },
      ],
    },

    showcase: {
      eyebrow: 'Software preview',
      title_a: 'From first contact to follow-up:',
      title_b: 'a more ordered flow for team and patient.',
      lead:
        'See how Prime Vision organises medical records, agenda, documents and follow-up in a single environment. Real screenshots, not fake renders.',
      ctaUnder: 'See Prime Vision in a 30-minute demo',
      tabs: [
        {
          key: 'login',
          label: 'Secure access',
          caption: 'Multi-role login with Continue with Google + email/password. Three distinct environments for Doctor, Secretary and Patient. AES-256 encryption and full GDPR compliance.',
          tag: '01 · ACCESS',
        },
        {
          key: 'appuntamenti',
          label: 'Smart agenda',
          caption: 'Multi-location full calendar (Milan, Naples, anywhere). Edit, reassign and manage every doctor\'s appointment from a single dashboard.',
          tag: '02 · AGENDA',
        },
        {
          key: 'linee',
          label: 'Always-updated guidelines',
          caption: 'AICCER, SICCSO, ESCRS and all major Italian and European scientific societies, always available inside the patient chart. Clinical decisions backed by up-to-date literature.',
          tag: '03 · KNOWLEDGE BASE',
        },
        {
          key: 'nuovo_appuntamento',
          label: 'New appointments',
          caption: 'Create a new appointment in 3 clicks: patient, location, doctor. Dynamic slots, preset visit reasons and automatic SMS confirmation.',
          tag: '04 · BOOKING',
        },
        {
          key: 'fatture',
          label: 'Invoice management',
          caption: 'Total invoiced, collected and outstanding in real time. Issue invoices in 2 clicks and archive in a compliant FSE 2.0 format.',
          tag: '05 · INVOICING',
        },
        {
          key: 'statistiche',
          label: 'Doctor performance',
          caption: 'Staff stats: total visits, completed, cancelled, completion rate, average wait time and patients seen. Per doctor, per day, per month.',
          tag: '06 · KPI STAFF',
        },
      ],
    },

    target: {
      eyebrow: 'Who it’s for',
      title_a: 'For practices that have grown beyond',
      title_b: 'spreadsheets, voice notes and disconnected tools.',
      lead:
        'If your practice is full but the team works in emergency mode, Prime Vision is here to bring back order — without slowing growth.',
      cards: [
        { title: 'Private eye practices', desc: 'More visits handled, no more admin chaos.' },
        { title: 'Eye clinics', desc: 'Doctors, rooms, agenda and follow-ups in one system.' },
        { title: 'Surgical centers', desc: 'More tracked paths, fewer manual steps, fewer errors.' },
        { title: 'Healthcare networks', desc: 'Multi-site, consolidated KPIs, uniform clinical governance.' },
      ],
    },

    ctaBlock: {
      surveyTag: '02 · SURVEY',
      surveyTitle: 'Is your practice ready for Prime Vision?',
      surveyDesc:
        'Take the questionnaire. In a few minutes you will discover how much time you’re losing today, which processes you can automate and whether Prime Vision fits your structure.',
      surveyBtn: 'Take the test',
      demoTag: '01 · DISCOVERY CALL',
      demoTitle: 'A 30-min call is the best way to understand it.',
      demoDesc:
        'Book a free call with our team: we\'ll call you back within 24h and show you how Prime Vision frees up hours of admin work every week.',
      demoBtn: 'Book a call',
    },

    preorder: {
      eyebrow: 'Early access · 2027',
      title_a: 'The first practices will get terms',
      title_b: 'that won\'t come back.',
      lead:
        'Who signs up now joins the first wave of onboarding and locks early-adopter terms before the early-2027 launch: price, priority setup, assisted migration.',
      perks: [
        { title: 'Price locked', desc: 'Early-adopter rate guaranteed for the first 24 months.' },
        { title: 'Priority setup', desc: 'First reserved practices are activated before everyone else.' },
        { title: 'Free migration', desc: 'Records, agendas and revenue imported from your old system.' },
        { title: 'Demo + consulting', desc: 'Dedicated medical consultant and product specialist by your side.' },
      ],
      stamp: 'FIRST WAVE · LIMITED SEATS',
      cta: 'Reserve your spot',
      cta_secondary: 'Talk to us',
    },

    contact: {
      eyebrow: 'Contact',
      title_a: 'If your practice is already full, you don\'t need more work.',
      title_b: 'You need more control.',
      lead:
        'Leave your details: we get back with a concrete proposal to assess whether Prime Vision fits your workflow. No templates, no aggressive sales.',
      firstName: 'First name',
      lastName: 'Last name',
      email: 'Email',
      phone: 'Phone number',
      birthDate: 'Date of birth',
      message: 'Message (optional)',
      messagePlaceholder: 'Tell us how your practice is organized today…',
      privacy_a: 'I accept the',
      privacy_b: 'privacy policy',
      privacy_c: ' and the processing of my data.',
      submit: 'I want to be contacted',
      submitting: 'Sending…',
      success: 'Request sent. We will contact you shortly.',
      error: 'Error while sending. Please try again.',
      required: 'Required field',
    },

    footer: {
      tagline: 'More clinical vision. Less paperwork.',
      links_company: 'Prime Vision',
      links_product: 'Product',
      links_legal: 'Legal',
      access: 'Sign in',
      demo: 'Demo',
      contact: 'Contact',
      survey: 'Ophthalmologists survey',
      privacy: 'Privacy policy',
      terms: 'Terms & conditions',
      copyright: '© {year} Prime Vision · All rights reserved',
      claim_a: 'More clinical vision. Less paperwork.',
      claim_b: 'Maximum care quality. Minimum management effort.',
    },
  },
};

export default dict;
